import React, { useContext } from 'react';
import DashboardGadgetBottomBar from '../../DashboardGadgetBottomBar';
import CanvasCard from '../../Visualisations/CanvasCard';
import FixedTrendCardContent from './FixedTrendCardContent';
import { TrendCardTopBar } from '../../Gadget/TrendCard';
import DashboardGadgetContext from '../../../contexts/DashboardGadgetContext';

const FixedTrendCardContainer = ({
  chartDefinition,
}: {
  chartDefinition: V5ChartDefinition;
}) => {
  const { dashboardGadget } = useContext(DashboardGadgetContext);

  return (
    <CanvasCard
      topBar={
        <TrendCardTopBar
          name={chartDefinition.name}
          chartDefinition={chartDefinition}
        />
      }
      content={<FixedTrendCardContent chartDefinition={chartDefinition} />}
      bottomBar={dashboardGadget ? <DashboardGadgetBottomBar /> : undefined}
    />
  );
};

export default FixedTrendCardContainer;
